import{css}from'glamor';export var small=css({width:120}).toString();export var big=css({width:170}).toString();